import React, { Component } from 'react'
import { connect } from "react-redux";
import { Table } from 'reactstrap';
import { Helmet } from 'react-helmet-async';
import IconButton from '@mui/material/IconButton';

import TextField from '@mui/material/TextField';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import {
	FormGroup,
	Label,
	Input,
} from 'reactstrap';

import ConfirmationDialog from "Routes/common/ConfirmationDialog";

import {
   allSSTeam,
   addSSTeam,
   editSSTeam,
   statusSSTeam,
   deleteSSTeam
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

class ssteam extends Component {
   
   constructor(props) {
      
      super(props);
        this.confirmationDialog = React.createRef();
         this.state = {
            adddiv:true,
            editdiv:false,
            eid:'',
            edname:'',
            eddesignation:'',
            edemail:'',
            edmobile:'',
         };      
      this.addHandleSubmit = this.addHandleSubmit.bind(this); 
      this.deleteTeam = this.deleteTeam.bind(this); 
      this.editTeam = this.editTeam.bind(this);
      this.statusTeam = this.statusTeam.bind(this);
      this.editHandleSubmit = this.editHandleSubmit.bind(this);
      this.onBackSection = this.onBackSection.bind(this);
      
   }

   UNSAFE_componentWillMount() {
		this.props.allSSTeam();
	}
   
   addHandleSubmit(event) {
      event.preventDefault();
      this.props.addSSTeam(event).then((data) => {   
           
        if(data.status==1){
                
                document.getElementById("ssteamform").reset();
        }
    });
      
   }
   

   deleteTeam(data){
        this.data = data;
        this.confirmationDialog.current.openDialog();
    }

    deleteDataPermanent(popupResponse){
        
        if (popupResponse) {
            this.props.deleteSSTeam(this.data);
            this.data = ""
        }
    }

   editTeam(rawdata){
      
     

      this.setState({
         eid:rawdata.sctID,
         edname:rawdata.sc_name,        
         eddesignation:rawdata.sc_designation,        
         edemail:rawdata.sc_email,        
         edmobile:rawdata.sc_phone,        
         adddiv:false,
         editdiv:true
      });
   }

   editHandleSubmit(event) {
      event.preventDefault();
      this.props.editSSTeam(event,this.state.eid);      
   }

   

   statusTeam(roleid,status){
      this.props.statusSSTeam(roleid,status);       
   }

   onBackSection() {
		this.setState({ adddiv:true,
         editdiv:false });
	}

    render() {
       const { match, ssteamlists, loading } = this.props;
       return (
          <div className="saas-dashboard">
             <Helmet>
                <title>Sports Science Team | {AppConfig.appTitle}</title>
                <meta name="description" content="Sport Science Team" />
             </Helmet>
             <PageTitleBar title={<IntlMessages id="sidebar.ssteamheading" />} match={match} />
             <div className="row">
               <div className="col-sm-12 col-md-8">
                  <RctCollapsibleCard heading="List">
                     <div className="table-responsive">
                           <Table hover bordered striped>
                              <thead>
                                 <tr className="bg-primary text-white">
                                    <th>Sl.No</th>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Mobile</th>
                                    <th>Action</th>
                                 </tr>
                              </thead>
                              <tbody>                              
                              {ssteamlists.map((teamval,idx) => (
                                 <tr key={idx}>
                                    <td>{idx + 1}</td>
                                    <td>{teamval.sc_name}</td>
                                    <td>{teamval.sc_email}</td>
                                    <td>{teamval.sc_phone}</td>
                                    <td>
                                       {teamval.sc_status==1 ? (
                                          <a herf="" onClick={ ()=>this.statusTeam(teamval.sctID,0)}><span className="badge badge-info" >Active</span></a> 
                                       ) : (
                                          <a herf="" onClick={ ()=>this.statusTeam(teamval.sctID,1)}><span className="badge badge-danger" >Inactive</span></a> 
                                       )}
                                       <IconButton className="text-info" aria-label="edit" onClick={ ()=>this.editTeam(teamval)}><EditOutlinedIcon/></IconButton>
                                       <IconButton className="text-danger" aria-label="Delete" onClick={ ()=>this.deleteTeam(teamval.sctID)}><DeleteOutlineOutlinedIcon/></IconButton> 
                                       </td>
                                 </tr>
                              ))}
                                                      
                              </tbody>
                           </Table>
                     </div>
                  </RctCollapsibleCard>
               </div>  
               {this.state.adddiv && 
               <div className="col-sm-6 col-md-4">
                  <RctCollapsibleCard heading="Add Team">
                     <form id="ssteamform" autoComplete="off" onSubmit={(e)=>this.addHandleSubmit(e)}>
                        <div className="row">
                           <div className="col-sm-12 col-md-6 col-xl-12">
                              
                                <FormGroup>
                                    <Label for="Select">Name *</Label>
                                    <Input type="text" name="name" id="name" required/>
                                </FormGroup>
                                <FormGroup>
                                    <Label for="Select">Designation *</Label>
                                    <textarea rows="4" type="text" name="designation" id="designation" className="form-control form-control-alternative" required></textarea>
                                </FormGroup>
                                <FormGroup>
                                    <Label for="Select">Email *</Label>
                                    <Input type="text" name="email" id="email" required/>
                                </FormGroup>
                                <FormGroup>
                                    <Label for="Select">Mobile *</Label>
                                    <Input type="text" name="mobile" id="mobile" required/>
                                </FormGroup>                            
                              
                                <div className="form-group">
                                   <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" /> 
                                </div>
                           </div>   
                        </div>   
                     </form> 
                  </RctCollapsibleCard>  
               </div>
               }

               {this.state.editdiv && 
               <div className="col-sm-6 col-md-4">                   
                  <RctCollapsibleCard heading="Edit Team">                     
                     <form autoComplete="off" onSubmit={this.editHandleSubmit}>
                        <div className="row">
                           <div className="col-sm-12 col-md-6 col-xl-12">
                                <FormGroup>
                                    <Label for="Select">Name *</Label>
                                    <Input type="text" name="name" defaultValue={this.state.edname} required/>
                                </FormGroup>
                                <FormGroup>
                                    <Label for="Select">Designation *</Label>
                                    <textarea rows="4" type="text" name="designation" defaultValue={this.state.eddesignation} className="form-control form-control-alternative" required></textarea>
                                </FormGroup>
                                <FormGroup>
                                    <Label for="Select">Email *</Label>
                                    <Input type="text" name="email" defaultValue={this.state.edemail} required/>
                                </FormGroup>
                                <FormGroup>
                                    <Label for="Select">Mobile *</Label>
                                    <Input type="text" name="mobile" defaultValue={this.state.edmobile} required/>
                                </FormGroup>   
                              
                              <div className="form-group">
                                 <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Update" />
                                 <input type="button" className="mr-3 mb-3 btn btn-outline-warning" onClick={this.onBackSection} value="Back" />
                              
                              </div>
                           </div>   
                        </div>   
                     </form> 
                  </RctCollapsibleCard>  
               </div>
               }
             </div>
             <ConfirmationDialog
               ref={this.confirmationDialog}
               onConfirm={(res) => this.deleteDataPermanent(res)}
               data={'Team Member'}
            />
          </div>
       )
    }
 }




const mapStateToProps = ({ ssteam }) => {
	const { ssteamlists, loading } = ssteam;
	return { ssteamlists, loading };
}

export default connect(mapStateToProps, {
    allSSTeam,
    addSSTeam,
    editSSTeam,
    statusSSTeam,
    deleteSSTeam
})(ssteam); 